import React, { useEffect, useState, useMemo } from "react";
import { FormGroup } from "components/common";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Trans } from "react-i18next";
import { LocalForm } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import palette_icon from "assets/images/palette.svg";
import { useForm, useFieldArray, Controller, FormProvider } from "react-hook-form";
import { useBaseModal } from "services";
import { getColorsForStages } from "services/util";

export const Edit = ({
    t,
    list_id,
    client,
    stageAddToggleModal,
    stageAddToggle,
    getListStageRows,
    stageRows,
}) => {
    const [colorModalOpen, setColorModalOpen] = useState(false);
    const [currentStageIndex, setCurrentStageIndex] = useState(null);

    const colorToggleModal = () => {
        setColorModalOpen((prev) => !prev);
    };

    const colors_for_stages = useMemo(() => getColorsForStages(), []);

    const methods = useForm({
        mode: "onBlur",
        defaultValues: {
            stages: [
                { id: 1, name: "Stage 1", color_class: colors_for_stages[0] },
                { id: 2, name: "Stage 2", color_class: colors_for_stages[1] },
                { id: 3, name: "Stage 3", color_class: colors_for_stages[2] },
                { id: 4, name: "Stage 4", color_class: colors_for_stages[3] },
                { id: 5, name: "Stage 5", color_class: colors_for_stages[4] },
            ],
        },
    });

    const { reset, control, handleSubmit, watch, getValues, setValue } = methods;

    const { fields, append: appendStage, remove: removeStage } = useFieldArray({
        control,
        name: "stages",
        keyName: "key"
    });

    useEffect(() => {
        if (stageRows && stageRows.length > 0) {
            reset({
                stages: stageRows,
            });
        } else {
            reset(methods.defaultValues);
        }
    }, [stageRows, reset]);

    const handleAddStage = () => {
        const color = colors_for_stages[fields?.length % colors_for_stages.length];
        appendStage({
            id: fields?.length + 1,
            name: `Stage ${fields?.length + 1}`,
            color_class: color,
        });
    };

    const handleStagesSubmit = async (values) => {
        const stages = getValues("stages");
        const updatedValues = { stages: stages, list_id: list_id };
        await client.post(`list-details/${list_id}/pipeline-stage`, updatedValues)
            .then((data) => {
                NotificationManager.success(t("Stage created successfully"));
                getListStageRows();
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.error) {
                    NotificationManager.error(error.response.data.error);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            })
            stageAddToggleModal();
    };

    const selectStageBackgroundColor = (colorClass, index) => {
        const updatedStages = getValues("stages");

        if (updatedStages[index]) {
            updatedStages[index].color_class = colorClass;
            setValue("stages", updatedStages);
        } else {
            console.error(`Invalid index. Cannot update color_class.`);
        }
        colorToggleModal();
    };

    const openColorModalForStage = (index) => {
        const stages = getValues("stages");
        if (stages[index]) {
            setCurrentStageIndex(index);
            colorToggleModal();
        } else {
            console.error(`Invalid stage index: ${index}`);
        }
    };
    
    return (
        <>
            <Modal
                isOpen={colorModalOpen}
                toggle={colorToggleModal}
                size="sm"
                className="stage-color-modal position-absolute"
            >
                <ModalHeader toggle={colorToggleModal}><Trans>Select Color</Trans></ModalHeader>
                <ModalBody>
                    <div
                        className="justify-content-start flex-wrap d-flex ml-3"
                    >
                        {colors_for_stages.map((colorClass, index) => (
                            <div
                                key={index}
                                className={`list-color ${colorClass} clickable ml-1 mt-1`}
                                onClick={() => selectStageBackgroundColor(colorClass, currentStageIndex)}
                            />
                        ))}
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={stageAddToggle}
                toggle={stageAddToggleModal}
                className="right_modal"

            >
                <ModalHeader toggle={stageAddToggleModal}>
                    <Trans>Add new stage</Trans>
                </ModalHeader>
                <FormProvider {...methods}>
                    <LocalForm
                        className="container overflow-auto"
                        onSubmit={(values) => handleStagesSubmit(values)}
                    >
                        {fields?.map((field, index) => {
                            const n = (v) => `stages.${index}.${v}`;
                            return (
                                <div className="position-relative d-flex align-items-center" key={field?.id}>
                                        <Controller
                                            key={field?.id}
                                            control={control}
                                            name={n("name")}
                                            defaultValue={field?.name}
                                            render={({ field: controllerField }) => (
                                                <Input
                                                    {...controllerField}
                                                    className={`mt-2 p-4 ${field.color_class || colors_for_stages[4]}`}
                                                />
                                            )}
                                        />
                                    <FormGroup>
                                        <Controller
                                            key={field?.id}
                                            control={control}
                                            name={n("color_class")}
                                            defaultValue={field?.color_class}
                                            render={({ field: controllerField }) => (
                                                <Input
                                                type="hidden"
                                                    {...controllerField}
                                                    className={`mt-2 p-4 ${field.color_class || colors_for_stages[4]}`}
                                                />
                                            )}
                                        />
                                    </FormGroup>
                                    <div className="d-flex stage">
                                            <img
                                                className="fa fa-palette text-danger position-absolute stage-palette clickable"
                                                onClick={() => openColorModalForStage(index)}
                                                aria-hidden="true"
                                                src={palette_icon}
                                            >
                                            </img>
                                        <div className="mb-2">
                                            <i
                                                className="fa fa-times text-danger position-absolute stage-cross clickable"
                                                onClick={() => removeStage(index)}
                                                aria-hidden="true"
                                            >

                                            </i>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        <FormGroup className="mt-2">
                            <Button
                                color="primary"
                                className="form-control mb-3 mx-0 p-4 d-flex align-items-center justify-content-center "
                                onClick={() => handleAddStage()}
                            >
                                <i className="fa fa-plus mr-1"></i><Trans>ADD STAGE</Trans>
                            </Button>
                        </FormGroup>
                    </LocalForm>
                </FormProvider>
                <ModalFooter className="justify-content-start align-items-center mt-auto">
                    <div className="row align-items-center">
                        <div className="col">
                            <Button color="primary" type="submit" onClick={handleSubmit(handleStagesSubmit)}>
                                <Trans>Save</Trans>
                            </Button>
                        </div>
                        <div className="col">
                            <Button color="secondary" onClick={stageAddToggleModal}>
                                <Trans>Close</Trans>
                            </Button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Edit;
